<script setup>
import HelperResources from '@/components/result/HelperResources.vue'; 

const region = "seoul";
</script>

<template>
    <div class="slide-inner">
        <div class="content"> 
            <div class="card-wrap pt-10">
                <div class="card">
                    <h5 class="literacy">문해력·수리력 진단검사 결과, 학교에서 어떻게 활용하나요?</h5>
                    <ul class="use">
                        <li>
                            <n-flex :wrap="false" :size="40">
                                <div class="icon-wrap">
                                    <img src="@/assets/images/result/principal_03.png" />
                                    <p>교사 및 학급</p>
                                </div>
                                <div class="text-wrap">
                                    <p>S-PLAN 문항을 참고하여 학생의 삶과 연계된 수업-평가의 실천으로 수업 혁신</p>
                                    <p>학생의 강점과 보완할 점 파악 등 학생 개별 지도 및 맞춤형 지원 자료로 활용</p>
                                    <p>학생과 보호자 개별 상담 시 맞춤형 지원을 위한 객관적인 자료로 활용</p>
                                </div>
                            </n-flex>
                        </li>
                        <li>
                            <n-flex :wrap="false" :size="40">
                                <div class="icon-wrap">
                                    <img src="@/assets/images/result/principal_02.png" />
                                    <p>학년</p>
                                </div>
                                <div class="text-wrap">
                                    <p>학생 분반 및 학습 편성, 학년 특색교육활동 등 다음 학년도 학년 교육과정 설계에 반영</p>
                                    <p>방학 중 캠프, 전환기 교육활동, 학교자율시간 연계 프로젝트 등 운영</p>
                                </div>
                            </n-flex>
                        </li>
                        <li>
                            <n-flex :wrap="false" :size="40">
                                <div class="icon-wrap">
                                    <img src="@/assets/images/result/principal_01.png" />
                                    <p>학교</p>
                                </div>
                                <div class="text-wrap">
                                    <p>진단검사 결과를 학년말 학교 평가와 연계하여 교육활동 돌아보기 자료로 활용</p>
                                    <p>중점 및 특색활동, 학교자율 시간, 자유학기제(중등) 등 다음 학년도 학교 교육과정 설계에 반영</p>
                                    <p>가정과의 연계지도를 위해 보호자 연수 주제 및 자료로 활용</p>
                                </div>
                            </n-flex>
                        </li>
                    </ul>
                    <ul class="steps flex">
                        <li>
                            <div class="inner">
                                <p>서울 학생<br>문해력·수리력<br>진단검사 실시</p>
                                <p>10월 말~11월 초</p>
                            </div>
                        </li>
                        <li>
                            <div class="inner">
                                <p>서울 학생<br>문해력·수리력<br>진단검사 결과 수신</p>
                                <p>11월 말~12월 초</p>
                            </div>
                        </li>
                        <li>
                            <div class="inner">
                                <p>단위학교 학년협의회,<br>교육과정협의회 실시</p>
                                <p>11월 말~12월</p>
                            </div>
                        </li>
                        <li>
                            <div class="inner">
                                <p>다음 학년도 학교 및<br>학년 교육과정에 반영</p>
                                <p>12월~다음 학년도 1월</p>
                            </div>
                        </li>
                        <li>
                            <div class="inner">
                                <p>수업과 평가 혁신,<br>학생 맞춤형 지원<br>상담자료로 활용</p>
                                <p>다음 학년도 3~12월</p>
                            </div>
                        </li>
                    </ul>
                </div>       
                <div class="card pt-5">
                    <h5 class="numeracy">문해력·수리력 지도에 활용할 수 있는 자료는 무엇인가요?</h5>
                    <n-flex :wrap="false" justify="space-between" align="center" class="pt-[30px] pl-[60px] pr-[60px]"> 
                        <HelperResources />                       
                            <img src="@/assets/images/result/qr_large.png">                                         
                    </n-flex> 
                </div>
                <div class="card" :class="region">
                   <h5 class="total">문해력·수리력 진단검사의 문항은 일반 평가의 문항과 어떻게 다른가요?</h5>
                   <n-flex :wrap="false" :size="40">
                    <div class="char-wrap"><img src="@/assets/images/result/char_01.png"></div>                   
                    <div class="text-wrap">
                        <p>서울 학생 문해력·수리력 진단검사는 학생들이 알고 있는 것을 바탕으로 <strong class="font-medium">학습과 삶의 맥락에서 문제를 해결해 내는 능력을 측정</strong>할 수 있도록 문항이 구성되어 있습니다.</p>
                        <p>따라서 문항 형식은 학생 수준에 맞게 이미지, 도표, 그래프 등 다양한 텍스트가 반영된 복합 양식으로 제공됩니다.</p>
                    </div>
                   </n-flex>
                </div>
            </div>
       </div>
    </div>
</template>
<style lang="scss" scoped>
     h5 {
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        font-family: var(--smoe-font-visual);
        color: #fff;
        border-radius: 10px;         
        padding: 5px 0;
        &.literacy {background-color: var(--result-light-blue);}
        &.numeracy {background-color: var(--result-light-red);}
        &.total {background-color: #00A496;}        
    }
    ul.use {
        padding-top: 14px;
        li {
            padding: 16px 0;
            position: relative;
            &::before {
                content: ""; 
                background-image: url('@/assets/images/result/line.png');
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 1px;
            }
            .n-flex {            
                align-items: center;
                line-height: 1.7;
            }
            .icon-wrap {    
                width: 176px;
                height: 100px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                border-radius: 10px;
                background-color: #F5F5F5;
                gap: 5px;
            }
            .text-wrap {
                p {
                    position: relative;     
                    font-size: 20px;
                    &::before {
                        content: '-';
                        padding-right: 10px;
                    }
                }
            }
        }
    }
    ul.steps {
        width: 100%;
        gap: 25px;
        padding-top: 16px;
        li {
            width: calc((100% - 25px*4 ) / 5);       
            position: relative;
            font-size: 20px;
            &::after {
                content: '';
                background-image: url("@/assets/images/result/arrow_ic.png");
                width: 7px;
                height: 10px;
                background-repeat: no-repeat;
                background-size: contain;
                position: absolute;
                top: 50%;
                right: calc((-7px - 25px) / 2);
                transform: translateY(-50%);
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;                  
            }
            &:nth-child(5)::after {
                display: none;
            }
            .inner {
                text-align: center;
                width: 100%;
                height: 100%;
                border-radius: 10px;
                overflow: hidden;
                border: 1px solid #6484F0;
            }
            p:nth-child(1) {
                background-color: rgba(100, 132, 240,.1);
                height: calc(100% - 32px);
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: 1.2;
                padding: 5px;
            }
            p:nth-child(2) {
                background-color: #6484F0;
                color: #fff;
                height: 32px;
                line-height: 32px;
            }
        }
    }
    
    .card {
        &:nth-child(3) {
            padding-top:16px;
            .n-flex {
                padding: 50px 15px 0 15px;
            }
            .text-wrap {
                display: flex;
                flex-direction: column;
                gap: 18px;
                font-size: 21px;
                width: 100%;
                p {
                    padding-left: 30px;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        left: 15px;   
                        width: 4px;
                        height: 4px;
                        border-radius: 100%;         
                        top: 10px;              
                        background-color: #000; 
                    }
                }
            }
            .char-wrap {display: none;}
        }
        &.seoul {
            .char-wrap {
                display: block;
                padding-left: 15px;
                img {
                    width: 184px;
                    height: 153px;
                }                
            }
            .text-wrap {
                width: calc((100% - 40px) - 183px);
            }
        }
    }
</style>